import FuseUtils from '@fuse/utils';
import authRoles from 'app/auth/authRoles';
import { userRoleSelector } from 'app/auth/store/user.selector';
import { useLatestRequest } from 'app/main/mobile/useLatestRequest';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getCampaignReminderApi } from '../api/campaign.api';
import { CampaignReminder } from './campaignReminder';

// The menu badge and the campaign page alert both read the reminder, so they share one request per pathname.
let pendingRequest: { pathname: string; promise: Promise<CampaignReminder> } | null = null;

const fetchCampaignReminder = (pathname: string): Promise<CampaignReminder> => {
  if (pendingRequest?.pathname === pathname) return pendingRequest.promise;
  const promise = getCampaignReminderApi().finally(() => {
    if (pendingRequest?.promise === promise) pendingRequest = null;
  });
  pendingRequest = { pathname, promise };
  return promise;
};

export const useCampaignReminder = (): CampaignReminder | null => {
  const { pathname } = useLocation();
  const role = useSelector(userRoleSelector);
  const isOwner = Boolean(FuseUtils.hasPermission(authRoles.owner, role));
  const startRequest = useLatestRequest();
  const [reminder, setReminder] = useState<CampaignReminder | null>(null);

  useEffect(() => {
    const isLatest = startRequest();
    if (!isOwner) {
      setReminder(null);
      return;
    }
    fetchCampaignReminder(pathname).then(
      response => {
        if (isLatest()) setReminder(response);
      },
      () => {
        if (isLatest()) setReminder(null);
      },
    );
  }, [isOwner, pathname, startRequest]);

  return reminder;
};
